import { ConfirmationDialog } from "@/components/shared/confirmation-dialog";

export interface ReferenceRenameDialogProps {
    open: boolean;
    clientKey: string;
    origin: string;
    destination: string;
    occurrenceCount: number;
    isPending?: boolean;
    onConfirm: (clientKey: string, destination: string) => void;
    onCancel: () => void;
}

const times = (count: number) => `${count} ${count === 1 ? "time" : "times"}`;

export function ReferenceRenameDialog({
    open,
    clientKey,
    origin,
    destination,
    occurrenceCount,
    isPending = false,
    onConfirm,
    onCancel,
}: ReferenceRenameDialogProps) {
    return (
        <ConfirmationDialog
            open={open}
            onOpenChange={(next) => {
                if (!next) onCancel();
            }}
            title="Rename reference?"
            description={
                <>
                    &quot;{origin}&quot; is @-referenced{" "}
                    {times(occurrenceCount)}. Renaming it to &quot;{destination}
                    &quot; leaves those mentions pointing at the old name, so
                    they will read as invalid until you fix them.
                </>
            }
            onConfirm={() => onConfirm(clientKey, destination)}
            confirmLabel="Rename"
            isPending={isPending}
            closeOnConfirm={false}
        />
    );
}
